import otoLogo from '../assets/img/portfolio/oto.png'
import bizzTMLogo from '../assets/img/portfolio/bizztm.svg'
import apnacomplexLogo from '../assets/img/portfolio/apnacomplex.png'
import livspaceLogo from '../assets/img/portfolio/livspace.png'
import credrLogo from '../assets/img/portfolio/credr.png'
import ukeyoLogo from '../assets/img/portfolio/ukeyo-inverted.png'
import multilivingLogo from '../assets/img/portfolio/multiliving.png'
import aeriaLogo from '../assets/img/portfolio/aeria-inverted.png'
export const PortfolioList = [
    {
        logo: otoLogo,
        name: 'OTO Capitals'
    },
    {
        logo: bizzTMLogo,
        name: 'BizzTM'
    },
    {
        logo: apnacomplexLogo,
        name: 'ApnaComplex'
    },
    {
        logo: multilivingLogo,
        name: 'Multiliving'
    },
    {
        logo: livspaceLogo,
        name: 'Livspace'
    },
    {
        logo: credrLogo,
        name: 'CredR'
    },
    {
        logo: ukeyoLogo,
        name: 'Ukeyo'
    },
    {
        logo: aeriaLogo,
        name: 'Aeria'
    }
]